import { styled } from '@mui/system';
import MuiPhoneNumber from 'material-ui-phone-number';

export const StyledPhoneInput = styled(MuiPhoneNumber)(({ theme }) => ({
  ...theme.typography.body1,
  marginBottom: '24px !important',
}));
